import React from 'react';
import ProbateChoice from './ProbateChoice';

export default class SpouseProbateChoice extends ProbateChoice {
  static forSpouse = true;
}
